import PropertyChatContainer from 'app/sm/property_chat/property_chat_container'

export default PropertyChatContainer
